// Loops each [data-speed-demo] element between a "loading" state and a
// "loaded" state, using the exact durations set on the element (so the
// slow demo and the fast demo can run at different speeds side by side).
(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function runCycle(el) {
    var loadMs = parseInt(el.getAttribute('data-load-ms'), 10) || 3000;
    var holdMs = parseInt(el.getAttribute('data-hold-ms'), 10) || 5000;

    if (prefersReducedMotion) {
      el.classList.add('is-loaded');
      return;
    }

    function tick() {
      el.classList.remove('is-loaded');
      setTimeout(function () {
        el.classList.add('is-loaded');
        setTimeout(tick, holdMs);
      }, loadMs);
    }

    tick();
  }

  document.querySelectorAll('[data-speed-demo]').forEach(runCycle);
})();
